import {
  add,
  getDate,
  getHours,
  getMinutes,
  getDay,
  getMonth,
  getSeconds,
  getYear,
} from "date-fns";
import firebase from "firebase/compat/app"; //v9
import moment from "moment";
import { useTranslation } from "react-i18next";

export const getSingleDate = (date, end, time = true) => {
  if (end) date = add(date, { days: 1 });

  let day = getDate(date);
  let month = getMonth(date) + 1;
  let year = getYear(date);
  let hours = getHours(date);
  let minutes = getMinutes(date);
  let seconds = getSeconds(date);

  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  if (time) {
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day}`;
};

export const formatDate = (date) => {
  return {
    start: getSingleDate(date.startDate, false),
    end: getSingleDate(date.endDate, true),
    endCSV: getSingleDate(date.endDate, false),
    type: "range",
    msgType: "calendar",
  };
};

export const useFormatDateDisplay = () => {
  const { t } = useTranslation();
  const months = t("monthsList");

  return (date) => {
    const start = `${months[getMonth(date.startDate)]} ${getDate(
      date.startDate,
    )}`;
    const end = `${months[getMonth(date.endDate)]} ${getDate(date.endDate)}`;
    return `${start} - ${end}`;
  };
};

export const useFormatSingleDate = () => {
  const { t } = useTranslation();
  const months = t("monthsList");

  return (date) => {
    return `${months[getMonth(date)]} ${getDate(date)}, ${getYear(date)}`;
  };
};

export const useGetFullDate = () => {
  const { t } = useTranslation();
  const formatSingleDate = useFormatSingleDate();
  const days = t("daysList");

  return (date) => `${days[getDay(date)]}, ${formatSingleDate(date)}`;
};

export const get12Hour = (date) => {
  let hours = getHours(date);
  let minutes = getMinutes(date);
  const ampm = hours < 12 ? "AM" : "PM";
  hours = hours > 12 ? hours - 12 : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${hours}:${minutes} ${ampm}`;
};

export const getTrypTime = (startDate, endDate) => {
  return `${get12Hour(startDate)} - ${get12Hour(endDate)}`;
};

export const useGetTrypLength = () => {
  const { t } = useTranslation();

  return (startDate, endDate) => {
    const mins = Math.round((endDate - startDate) / 60000);

    return mins < 1
      ? t("under1min")
      : mins > 59
      ? t("numHours", { num: Math.round((mins / 60) * 10) / 10 })
      : t("numMins", { num: mins });
  };
};

export const convertTimestamp = (date) => {
  return new firebase.firestore.Timestamp(
    date._seconds,
    date._nanoseconds,
  ).toDate();
};

export const useFormatTimestamp = (date) => {
  const { t } = useTranslation();
  const months = t("monthsList");

  const jsDate = convertTimestamp(date);
  const month = months[jsDate.getMonth()];
  const day = jsDate.getDate();
  const year = jsDate.getFullYear();
  return `${month} ${day}, ${year}`;
};

export const getNext15 = () => {
  let date = new Date();
  return new Date(Math.ceil(date.getTime() / 900000) * 900000);
};

export const convertSecondsToDate = (seconds) => {
  return moment(seconds * 1000).toDate();
};

export const getCampaignDateRangeString = (startDate, endDate) => {
  const differentYears = (date) => {
    if (moment(startDate).year() !== moment(endDate).year()) {
      return `, ${moment(date).format("YYYY")}`;
    }

    return "";
  };

  return `${moment(startDate).format("MMM D")}${differentYears(
    startDate,
  )} - ${moment(endDate).format("MMM D")}${differentYears(endDate)}`;
};
